import { render, staticRenderFns } from "./construction.vue?vue&type=template&id=8d16ffbc"
import script from "./construction.vue?vue&type=script&lang=js"
export * from "./construction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d16ffbc')) {
      api.createRecord('8d16ffbc', component.options)
    } else {
      api.reload('8d16ffbc', component.options)
    }
    module.hot.accept("./construction.vue?vue&type=template&id=8d16ffbc", function () {
      api.rerender('8d16ffbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/construction.vue"
export default component.exports